import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import api from "../lib/api";
import { formatApiError } from "../lib/utils.helpers";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const [website, setWebsite] = useState(""); // Honeypot anti-spam — must stay empty

  const submit = async (e) => {
    e.preventDefault();
    if (website) { toast.success("Message envoyé !"); return; } // Silent drop for bots
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé !");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="container-x py-16" data-testid="contact-page">
      <p className="overline text-[#2B8B8E]">Contact</p>
      <h1 className="text-4xl sm:text-5xl font-light mt-2 mb-12">Parlons de votre projet.</h1>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-6 text-sm text-muted-foreground">
          <div className="flex gap-3"><MapPin size={18} className="text-[#2B8B8E] shrink-0" /><div><p className="font-medium text-foreground">Adresse</p>Vauvert, 30600, Gard</div></div>
          <div className="flex gap-3"><Phone size={18} className="text-[#2B8B8E] shrink-0" /><div><p className="font-medium text-foreground">Téléphone</p><a href="tel:+33762369551" className="hover:text-[#2B8B8E]">07 62 36 95 51</a></div></div>
          <div className="flex gap-3"><Mail size={18} className="text-[#2B8B8E] shrink-0" /><div><p className="font-medium text-foreground">Email</p><a href="mailto:synergieworkspace@gmail.com" className="hover:text-[#2B8B8E]">synergieworkspace@gmail.com</a></div></div>
          <div className="pt-4 border-t border-border">
            <p className="font-medium text-foreground mb-1">Horaires</p>
            7 jours sur 7 : 7h – 20h
          </div>
        </div>

        <form onSubmit={submit} className="md:col-span-7 border border-border rounded-3xl p-7 bg-card space-y-4" data-testid="contact-form">
        {/* Honeypot field — hidden from users, filled only by bots */}
        <div style={{ position: "absolute", left: "-9999px", top: 0 }} aria-hidden="true">
          <label htmlFor="website">Site web (ne pas remplir)</label>
          <input type="text" id="website" name="website" tabIndex="-1" autoComplete="off"
            value={website} onChange={(e) => setWebsite(e.target.value)} />
        </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Label>Nom</Label>
              <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
            </div>
            <div>
              <Label>Email</Label>
              <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
            </div>
          </div>
          <div>
            <Label>Sujet</Label>
            <Input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" />
          </div>
          <div>
            <Label>Message</Label>
            <Textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
          </div>
          <Button type="submit" disabled={sending} className="bg-[#2B8B8E] hover:bg-[#1F6F73] text-white rounded-full px-8" data-testid="contact-submit">
            {sending ? "Envoi…" : "Envoyer le message"}
          </Button>
        </form>
      </div>
    </div>
  );
}
